import { applyColorMode } from './appleTokens';

// Apparence de l'ERP (menu du profil, en haut à droite) : claire, sombre ou celle du système. Choix mémorisé dans le
// navigateur ; appliqué aux tokens au chargement de ce module — index.js l'importe EN PREMIER, avant tout composant
// (certains styles sont calculés au chargement des modules). Changer d'apparence recharge donc la page.

const STORAGE_KEY = 'erp.colorMode';
export const COLOR_MODES = ['light', 'dark', 'system'];

/** Choix mémorisé : 'light' | 'dark' | 'system' (défaut : clair, l'apparence historique). */
export function getColorModePreference() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return COLOR_MODES.includes(v) ? v : 'light';
  } catch {
    return 'light';
  }
}

function systemPrefersDark() {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  } catch {
    return false;
  }
}

/** Apparence effective ('light' | 'dark') d'un choix. */
export function resolveColorMode(pref = getColorModePreference()) {
  if (pref === 'system') return systemPrefersDark() ? 'dark' : 'light';
  return pref === 'dark' ? 'dark' : 'light';
}

/** Mémorise le choix et recharge la page s'il change l'apparence affichée. */
export function setColorModePreference(pref) {
  if (!COLOR_MODES.includes(pref)) return;
  const before = resolveColorMode();
  try {
    localStorage.setItem(STORAGE_KEY, pref);
  } catch {
    // Stockage indisponible : choix non mémorisé.
  }
  if (resolveColorMode(pref) !== before) window.location.reload();
}

applyColorMode(resolveColorMode());
try {
  document.documentElement.style.colorScheme = resolveColorMode();
} catch {
  /* hors navigateur (tests) */
}

// « Système » : suit le changement d'apparence de l'ordinateur.
try {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (getColorModePreference() === 'system') window.location.reload();
  });
} catch {
  /* navigateur ancien / tests */
}
